import stackblur from 'stackblur';
const isOldBrowser = (
 /MSIE 10/i.test(navigator.userAgent) ||
 /MSIE 9/i.test(navigator.userAgent) ||
 /rv:11.0/i.test(navigator.userAgent) ||
 /Edge\/\d./i.test(navigator.userAgent) ||
 navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ||
 /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
);
const animateFallback = true;
const showBlur = !isOldBrowser;
function lerp(a,b,t){
    return a + (b - a) * t;
}
function easeInOutQuad(t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t }
function timer({duration,easing=easeInOutQuad,onTick,onComplete,autostart=true}){
    let startTime=0,paused=true,currentFrame;
    function tick(){
        if(paused) return;
        const progress = Math.min(1,Math.max(0,(performance.now() - startTime) / duration));       
        currentFrame=requestAnimationFrame(tick);
        onTick&&onTick(easing?easing(progress):progress);
        if(progress >= 1){
            currentFrame&&cancelAnimationFrame(currentFrame);
            currentFrame = null;
            paused=true;
            onComplete&&onComplete();
        }
    }

    const control = {
        start(){
            startTime=performance.now();
            paused=false;
            currentFrame=requestAnimationFrame(tick);
        },
        pause(){
            currentFrame&&cancelAnimationFrame(currentFrame);
            currentFrame = null;
            paused=true;
        }
    }

    if(autostart) setTimeout(control.start,0);

    return control;
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function getBlurredImage(originalImage,blurAmount=28){
    return new Promise((res,rej) => {
        const img = new Image();
        img.onload = ()=>{
            const c = document.createElement('canvas');
            const {width,height} = img;
            c.width = width;
            c.height = height;
            const ctx = c.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const imgData = ctx.getImageData(0,0,width,height);
            stackblur(imgData.data,width,height,blurAmount);
            ctx.putImageData(imgData,0,0);
            res({src:c.toDataURL(),width,height});
        }
        img.src = originalImage;
    });
}

const getBackgroundImagePath = element => ((element.style.backgroundImage || '').replace('url(','').replace(')','').replace(/\"/gi, ""));

function clippedBackgroundImage(blurredImageData,normalImageSrc,container){
    const $ = window.jQuery;

    container.css('background-image','none');

    const id = clippedBackgroundImage.id = (clippedBackgroundImage.id||0) + 1;
    const blurredPathData=(width,height,steep=.225,offsetX=0.9)=>`M${width * (.5+steep) * offsetX} 0 H ${width} V ${height} H ${width * (.5-steep) * offsetX} L ${width * (.5+steep) * offsetX} 0`;
    const normalPathData=(width,height)=>`M0 0 H ${width} V ${height} H 0 L 0 0`;

    let svg,blurredPath,blurredPattern,blurredImage,blurredRect,pattern,image,path;

    const animationTransform = (scale,rotation) => {
        const w = container.width();
        const h = container.height();
        const offsetX = ((w * scale) - w) / -2;
        const offsetY = ((h * scale) - h) / -2;

        return `translate(${w / 2} ${h / 2}) rotate(${rotation}) translate(${(w / -2) + offsetX} ${(h / -2) + offsetY}) scale(${scale})`
    }

    function update(){
        const width = container.width();
        const height = container.height();
        const initialTransform = animationTransform(1.1,0);

        if(!showBlur){
            if(!svg){
                svg = $(`
                    <svg id="pcpbg_${id}" viewBox="0 0 ${width} ${height}">
                        <path id="#pcpblurredpath_${id}" class="image-blur-tint" d="${blurredPathData(width,height)}" />
                    </svg>
                `);

            }else{
                svg.attr('viewBox',`0 0 ${width} ${height}`);
                /*pattern.attr({width,height});
                blurredPattern.attr({width,height});
                image.attr({width,height});
                blurredImage.attr({width,height});
                path.attr('d',normalPathData(width,height));*/
                blurredPath.attr('d',blurredPathData(width,height));
            }
            
            return;
        }

        if(!svg) {
            svg = $(`
                <svg id="pcpbg_${id}" viewBox="0 0 ${width} ${height}">
                    <defs>
                        <pattern id="pcpblurredpattern_${id}" class="image-pattern" patternUnits="userSpaceOnUse" width="${width}" height="${height}">
                            <image id="pcpblurredimage_${id}" xlink:href="${blurredImageData.src}" width="${width}" height="${height}" x="0" y="0" preserveAspectRatio="xMinYMin slice" />
                            <rect id="pcpblurredimagetint_${id}" class="image-blur-tint" fill="rgba(0,0,0,0)" width="${width}" height="${height}" />
                        </pattern>
                        <pattern id="pcppattern_${id}" class="image-pattern" patternUnits="userSpaceOnUse" width="${width}" height="${height}">
                            <image id="pcpimage_${id}" xlink:href="${normalImageSrc}" width="${width}" height="${height}" x="0" y="0" preserveAspectRatio="xMinYMin slice" />
                        </pattern>
                    </defs>

                    <path id="pcppath_${id}" d="${normalPathData(width,height)}" fill="url(#pcppattern_${id})" />
                    <path id="pcpblurredpath_${id}" d="${blurredPathData(width,height)}" fill="url(#pcpblurredpattern_${id})" />
                    
                </svg>
            `).appendTo(container);
            blurredPattern = svg.find(`#pcpblurredpattern_${id}`);
            pattern = svg.find(`#pcppattern_${id}`);
            blurredImage = svg.find(`#pcpblurredimage_${id}`);
            image = svg.find(`#pcpimage_${id}`);
            blurredPath = svg.find(`#pcpblurredpath_${id}`);
            path = svg.find(`#pcppath_${id}`);
        }else{
            svg.attr('viewBox',`0 0 ${width} ${height}`);
            pattern.attr({width,height});
            blurredPattern.attr({width,height});
            image.attr({width,height});
            blurredImage.attr({width,height});
            path.attr('d',normalPathData(width,height));
            blurredPath.attr('d',blurredPathData(width,height));
        }
    }
    update();
    let animation;
    function animate(){
        animation&&animation.pause();
        const targets = svg.find('.image-pattern');
        if(!animateFallback) return;
        animation = timer({
            duration:6000,
            onTick(t){
                const transform = animationTransform(
                    lerp(1.1,1.2,t),
                    lerp(0,0.02,t)
                );
                targets.each(function(){
                    this.setAttribute('patternTransform',transform);
                });
            },
            onComplete(){
                animation=null;
            }
        });
    }
    function clearAnimation(){
        animation&&animation.pause();
        animation=null;
        svg.find('.image-pattern').attr('patternTransform',animationTransform(1.1,0));
    }

    $(window).on('resize',debounce(update,200));

    function change(){
        clearAnimation();
        const current = !!container.parents('.slick-current:first').length;
        const active = !!container.parents('.slick-active:first').length;
        if(!current) return;
        animate();
    }

    container.parents('.slider-background:first').on('init reInit afterChange',change);

    change();
}

function clippedBackgroundRect(container){
    const $ = window.jQuery;

    const id = clippedBackgroundRect.id = (clippedBackgroundRect.id||0) + 1;
    const blurredPathData=(width,height,steep=.225,offsetX=0.9)=>`M${width * (.5+steep) * offsetX} 0 H ${width} V ${height} H ${width * (.5-steep) * offsetX} L ${width * (.5+steep) * offsetX} 0`;

    let svg,blurredPath;

    function update(){
        const width = container.width();
        const height = container.height();
        if(!svg){
            svg = $(`
                <svg id="pcpbg_${id}" viewBox="0 0 ${width} ${height}">
                    <path id="pcpblurredpath_${id}" class="image-blur-tint" d="${blurredPathData(width,height)}" />
                </svg>
            `).appendTo(container);
            blurredPath = svg.find(`#pcpblurredpath_${id}`);
        }else{
            svg.attr('viewBox',`0 0 ${width} ${height}`);
            blurredPath.attr('d',blurredPathData(width,height));
        }  
    }
    update();
    
    $(window).on('resize',debounce(update,200));
    container.parents('.slider-background:first').on('init reInit afterChange',update);
    $(window).on('load',debounce(update,200));
    //IIIIIIHHHHH
    setTimeout(update,1000);
}

export default function slide(){
    const $ = window.jQuery;
    const slideElement = $(this);
    const imageElement = slideElement.find('.item');
    const blurElement = slideElement.find('.blur');

    // $('.slider-content-wrapper').hide();

    if(!blurElement.length) return;

    const imagePath = getBackgroundImagePath(imageElement[0]);

    const id = (slide.idcount = 1+(slide.idcount || 0));

    function withBlurredImage(blurredImage){        
        if(isOldBrowser){
            if(blurredImage){
                clippedBackgroundImage(blurredImage,imagePath,blurElement);
                blurElement.parent().addClass('svg-fallback');
                imageElement.css('background-image','none');
            }else{
                clippedBackgroundRect(blurElement);
                blurElement.parent().addClass('svg-rect-fallback');
                blurElement.css('background-image','none');
            }   
        }else{
            blurElement.attr('id',`slide-blur-image-${id}`)
            $(`<style>#slide-blur-image-${id}::before{background-image:url(${blurredImage.src});}</style>`).appendTo('body');
        }
    }

    if(!showBlur){
        withBlurredImage(null);
    }else{
        getBlurredImage(imagePath).then(withBlurredImage);
    }
}